import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PersonSearchService } from '../_services/person-search.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyInsightsService } from '../_services/company-insights.service';
import moment from 'moment';
import { LocalStorageService } from '../_services/local-storage.service';

@Component({
    selector: 'app-company-insights-history-mdoal',
    templateUrl: './company-insights-history-mdoal.component.html',
    styleUrls: ['./company-insights-history-mdoal.component.scss'],
    standalone: false
})
export class CompanyInsightsHistoryMdoalComponent implements OnInit {

  /**List of all search */
  @Input() historyData: {
    type?: string,
    name?: string,
    companylogo?: string,
    companyid?: string,
    updatedon?: string,
  }[] = [];

  /**pagination of search histroy */
  searchHistoryPagination = 0;

  /**Used to notify that something is selected from histroy modal */
  @Output() historyClicked: EventEmitter<any> = new EventEmitter();

  constructor(private activeModal: NgbActiveModal, private companyinsightssevice: CompanyInsightsService, private personSearchService: PersonSearchService, private route: ActivatedRoute, private router: Router,
    private localStorageService: LocalStorageService
  ) { }

  ngOnInit() {
    this.getHistory()
  }

  /**
   * Get recent search history
   */
  async getHistory(type = '') {
    if (type == 'scroll') {
      this.searchHistoryPagination += 10;
    }
    const { historyData, recentSearchData } = await this.companyinsightssevice.getCompanyInsightsRecentSearchAndHistory(this.searchHistoryPagination);
    historyData.forEach(item=>{
      if(item.name.includes(';')) {
        item.name = item.name.replace(/;/g, ' vs ')
      }
      this.historyData.push(item);
    })
  }


  /**
   * Select recent history entery
   * @param data
   */
  selectRecentHistory(data) {
    if (data.type === 'company') {
      this.companyinsightssevice.setCompanyInsightsHistory({ companies: [data.name], id: [data.companyid] }, 'company')
      this.router.navigate([`/company-details/${data.companyid}`]);
    } else if (data.type === 'company comparison') {
      if(data?.id?.length) {
        this.localStorageService.setItem('companyOneId', data.id[0]);
        this.localStorageService.setItem('companyTwoId', data.id[1].trim());
        this.router.navigate(['/company-compare']);
      }
      // console.log(data);
      // this.companyinsightssevice.setCompanyInsightsHistory({ name: data.name }, 'industry')
    //  this.router.navigate(['/company-list'], { queryParams: { keyword: data.name } })
    }
    this.searchHistoryPagination = 0;
    this.activeModal.dismiss();
  }

  /**
     * Foramt date in ('Do MMM YY | hh:mm A') format
     * @param x date
     * @returns
     */
  formatDate(x) {
    return moment(x).format('Do MMM YY | hh:mm A')
  }


  /**used to dismiss histroy modal */
  closeModal() {
    this.activeModal.dismiss();
  }

}
